
<template>

    <div class="outer-wrapper">
        
        <div class="details-wrapper">

            <div class="logo-wrapper">

                <img :src=" getLogoMerchantUrl( merchantSlug ) " @error="$event.target.src = '../../img/expressorders/logo.jpg'" alt=""/>
            </div>

            <h2>Sorry!</h2>
            <p>
                This may be a duplicate order. We see that you placed an order a few minutes ago.
            </p>
            <p class="edit-order-duplicate-button">
                If you are looking for that order please see the order history
                <p>
                    <button class="button btn-blue"   @click="goToOrderHistory()">
                        Click Here
                    </button>
                </p>
            <p>
                If you are really intending to place another order, please wait a few minutes then try the order again.
            </p>
            <p>
                We are sorry for the inconvenience.
            </p>

        </div>

    </div>

</template>

<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import { mapGetters } from 'vuex';

    export default {

        name: 'order-duplicate-failure',
        computed: {

            ...mapGetters({

                merchantSlug                : 'merchant/merchantSlug',
                allMerchantsWithImages      : 'merchant/allMerchantsWithImages',
                imageUrl                    : 'imageUrl',
            })
        },
        methods: {
            getLogoMerchantUrl( slug ){
                var urlImagesFromStaticRealPayment = '';
                const merchantsLogos = this.allMerchantsWithImages;
                merchantsLogos.forEach( merchantLogo => {
                    if (merchantLogo.slug == slug) {
                        urlImagesFromStaticRealPayment = merchantLogo.imagePath + merchantLogo.imageName;
                    }     
                });
                
                return this.imageUrl + urlImagesFromStaticRealPayment
            },
            goToOrderHistory(){

                this.$router.replace({
                    name: 'order-history'
                });
            },
        },
        components: {

            FontAwesomeIcon
        }
    }
</script>

<style scoped>

    .outer-wrapper {

        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 10px !important;
    }
    .check-circle {

        color: #65A52B;
        font-size: 125px;
    }
    .logo-wrapper {
        text-align: center;
        padding: 10px 5px;

        width: 125px;
        margin: auto;
    }
    .logo-wrapper > img {

        width: 100%;
        height: 100%;
    }
    .details-wrapper {

        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .details-wrapper > h2 {

        margin: 0px auto;
    }
    .details-wrapper > p {

        margin: 0 auto 15px;
        text-align: center;
        max-width: 250px;
    }
    .subtext {

        font-size: 0.8rem;
    }
    .edit-order-duplicate-button {

        margin: 10px;
        color: rgb( 21, 66, 198 );
        cursor: pointer;
    }
</style>